const html = require('choo/html');
const uploadProtection = require('./uploadProtection');

module.exports = function syndisDataTile(state, emit) {
  const emailList = localStorage.getItem('emailList');
  if (emailList) {
    state.syndisInputs.emailInput = emailList;
  }

  return html`
    <send-intro
      class="flex flex-col items-center justify-center bg-white px-6 md:py-0 py-6 mb-0 h-full w-full dark:bg-grey-90 relative"
    >
      <div class="mt-10 flex flex-col leading-loose h-full w-full">
        <h1 class="text-3xl font-bold md:pb-2">
          ${state.translate('settings')}
        </h1>

        <div class="flex mt-1">
          <label class="text-md" for="email-input">
            ${state.translate('email')}
          </label>

          <span
            class="question-icon self-center ml-1 cursor-pointer group"
            role="tooltip"
            aria-label="${state.translate('emailInfo')} ${state.translate(
              'commaSeperated'
            )}"
          >
            <p class="tooltip">
              ${state.translate('emailInfo')}
              ${state.translate('commaSeperated')}
            </p>
          </span>

          <label
            id="email-msg"
            class="self-end text-sm text-red mr-1 ml-auto dark:text-red-40
                    ${state.emailError ? '' : 'invisible'}"
            for="email-input"
          >
            ${state.translate('invalid')}
          </label>
        </div>

        <input
          id="email-input"
          class="w-full border-[1px] rounded leading-loose px-2 py-1 dark:bg-grey-80 
            ${state.syndisInputs.emailError ? 'border-red' : ''}"
          type="email"
          oninput="${emailChanged}"
          placeholder="${state.translate('emailPlaceholder')}"
          value="${state.syndisInputs.emailInput || ''}"
          autocomplete="off"
          data-item="email"
        />

        <div class="flex">
          <label class="text-md mt-1" for="description-input">
            ${state.translate('description')}
          </label>

          <span
            class="question-icon self-center ml-1 cursor-pointer group"
            role="tooltip"
            aria-label="${state.translate('descriptionInfo')}"
          >
            <p class="tooltip">
              ${state.translate('descriptionInfo')}
            </p>
          </span>
        </div>

        <input
          id="description-input"
          class="w-full border-[1px] rounded leading-loose px-2 py-1 dark:bg-grey-80"
          type="text"
          autocomplete="off"
          oninput="${descriptionchanged}"
          placeholder="${state.translate('descriptionPlaceholder')}"
          value="${state.syndisInputs.descriptionInput || ''}"
          autocomplete="off"
        />

        ${uploadProtection(state, emit)}
      </div>
    </send-intro>
  `;

  function emailChanged(event) {
    state.syndisInputs.emailError = false;
    state.syndisInputs.emailInput = event.target.value;
    removeError(event);
  }

  function descriptionchanged(event) {
    event.stopPropagation();
    event.preventDefault();
    state.syndisInputs.descriptionInput = event.target.value;
  }

  function removeError(event) {
    event.stopPropagation();
    event.preventDefault();
    const item = event.target.dataset.item;
    const label = document.getElementById(item + '-msg');
    const input = document.getElementById(item + '-input');
    label.classList.add('invisible');
    input.classList.remove('border-red');
  }
};
